// deps
import React, { memo, ReactElement } from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// constants
import { TEXTS } from "@payment-ui/constants/index";

// styles
import { Banner, BannerCode, BannerContentContainer } from "./styles/OfferBanner.styled";

// test-ids
import { OFFER_BANNER_TEST_IDS } from "@swiggy-private/payment-test-ids";
import { getCloudinaryUrl } from "@swiggy-private/core-ui";

// helpers
import { isEmpty } from "@swiggy-private/js-utils";

interface OfferBannerProps {
    offerCode: string;
    offerHeaderText?: string;
}

function BannerIcon(): ReactElement {
    return (
        <img
            crossOrigin="anonymous"
            src={getCloudinaryUrl("PaymentLogos/paymentIcons/couponAppliedNew")}
            width={20}
            height={20}
        />
    );
}

// offer header text is entirely backend controlled header copy
// BAU flow used to push coupon code from backend and hardcode a copy from portal
// this didn't scale for MRO and AIP cases where we can multiple coupons
function OfferBanner(props: OfferBannerProps): ReactElement {
    const offerHeaderTextPresent = !isEmpty(props.offerHeaderText);

    return (
        <Banner data-testid={OFFER_BANNER_TEST_IDS.BANNER_CONTAINER}>
            <BannerIcon />

            <BannerContentContainer>
                {!offerHeaderTextPresent && (
                    <Text
                        variant="V2.body2.neutral.bold"
                        color="positive"
                        data-testid={OFFER_BANNER_TEST_IDS.BANNER_CODE}
                    >
                        {props.offerCode}
                    </Text>
                )}
                <BannerCode skipMargin={offerHeaderTextPresent}>
                    <Text
                        variant="V2.body2.neutral.medium"
                        color="positive"
                        data-testid={OFFER_BANNER_TEST_IDS.BANNER_TITLE}
                    >
                        {offerHeaderTextPresent ? props.offerHeaderText : TEXTS.OFFER_APPLIED}
                    </Text>
                </BannerCode>
            </BannerContentContainer>
        </Banner>
    );
}

export default memo(OfferBanner);
